import { CryptoJsService } from './../../services/crypto-js.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { first } from 'rxjs/internal/operators/first';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Message, MessageService } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import * as CryptoJS from 'crypto-js';
import { MenuService } from 'src/app/services/app.menu.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';


@Component({
  selector: 'app-tubewell-connection-login',
  templateUrl: './tubewell-connection-login.component.html',
  styleUrls: ['./tubewell-connection-login.component.scss']
})
export class TubewellConnectionLoginComponent implements OnInit {
  @Input("config") config: any = {
    type: 1,
    length: 6,
    cssClass: "custom",
    back: {
      stroke: "#2F9688",
      solid: "#f2efd2",
    },
    font: {
      color: "#000000",
      size: "35px",
    },
  };
  // @Input("config") config: any;
  @Output() captchaCode = new EventEmitter();

  captch_input: any = null;
  code: any = null;
  resultCode: any = null;
  checkCaptchaValue: boolean = false;

  isOTPSend: boolean = false;
  phoneNo: string;
  otp: string;
  public onAuthForm: FormGroup;
  submitted: boolean;
  validationOTP: any;
  btnDisabled: boolean = false;
  display: any;
  isSiteUnderMaintenance: boolean = false;
  ipAddress: any = '000.000.000';

  showAadhar = false;
  themeColor = '#2F9688';
  // themeColor = '#8b5815';
  otpTimer: any;

  otpBoxes = Array(6).fill(0);
  otpBoxValues: string[] = Array(6).fill('');
  otpBoxError: boolean = false;

  constructor(
    private authService: AuthenticationService,
    private service: MessageService,
    private _formBuilder: FormBuilder,
    public router: Router,
    private farmersDetailsService: FarmersApplicationService,
    private cryptoJS: CryptoJsService,
    private menuService: MenuService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService,
    private ipService: IpAddressService,
    private _personalDetalSer: FarmersDetailsService,
  ) { }

  ngOnInit(): void {
    this.getIP();
    sessionStorage.clear();
    // this.createCaptcha();
    this.getInitialToken();
    this.onAuthForm = this._formBuilder.group({
      aadhar: ['', [Validators.required, Validators.pattern(/^[0-9]{12}$/)]],
      otp: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
    });
    this.f.otp.disable();
  }

  checkCaptcha() {
    if (this.captch_input === this.resultCode) {
      this.checkCaptchaValue = true;
      return true;
    } else {
      this.checkCaptchaValue = false;
      return false;
    }
  }

  createCaptcha() {
    switch (this.config.type) {
      case 1: // only alpha numaric degits to type
        let char =
          Math.random()
            .toString(24)
            .substring(2, this.config.length) +
          Math.random().toString(24).substring(2, 4);
        this.code = this.resultCode = char.toUpperCase();
        break;
      case 2: // solve the calculation
      // let num1 = Math.floor(Math.random() * 99);
      // let num2 = Math.floor(Math.random() * 9);
      // let operators = ['+','-'];
      // let operator = operators[(Math.floor(Math.random() * operators.length))];
      // //this.code =  num1+operator+num2+'=?';
      // //this.resultCode = (operator == '+')? (num1+num2):(num1-num2);
      // break;
    }
    setTimeout(() => {
      let captcahCanvas: any = document.getElementById("captcahCanvas");
      var ctx = captcahCanvas?.getContext("2d");
      ctx.fillStyle = this.config?.back?.solid;
      ctx.fillRect(0, 0, captcahCanvas.width, captcahCanvas.height);

      ctx.beginPath();

      captcahCanvas.style.letterSpacing = 15 + "px";
      ctx.font = this.config.font.size + " " + this.config.font.family;
      ctx.fillStyle = this.config.font.color;
      ctx.textBaseline = "middle";
      ctx.fillText(this.code, 40, 50);
      if (this.config.back.stroke) {
        ctx.strokeStyle = this.config.back.stroke;
        for (var i = 0; i < 150; i++) {
          ctx.moveTo(Math.random() * 300, Math.random() * 300);
          ctx.lineTo(Math.random() * 300, Math.random() * 300);
        }
        ctx.stroke();
      }
    }, 100);
    // Generate captcha code and render it on canvas
  }

  // Function to reload captcha
  reloadCaptcha(): void {
    this.createCaptcha();
  }

  getInitialToken() {
    this.authService
      .getInitialToken()
      .pipe(first())
      .subscribe({
        next: (response) => {
          if (response) {
            sessionStorage.setItem("token", response.data)
          }
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: `Next level user not found. ${err}`,
          // });
        },
      });
  }

  get f() {
    return this.onAuthForm.controls;
  }

  onOTPClick() {
    this.captch_input = null;
    if (!this.f.aadhar.value) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Mobile Number Cant be Empty.' });
      return;
    }
    if (this.f.aadhar.value.length < 12) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Mobile Number Cant be Less than 10 Digits.' });
      return;
    }
    // this.disableOTPButton(2);

    this.sendAadharOTP();
    // return;

    // let body = {
    //   "mobileNo": this.cryptoJS.Encrypt(this.f.phoneNo.value),
    // }

    // let reqBodyFinal = {
    //   "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(body))
    // }

    // this.loader.start();
    // this.authService.getOTP(reqBodyFinal)
    //   .pipe(first())
    //   .subscribe({
    //     next: (data) => {
    //       data = JSON.parse(data)
    //       data = this.cryptoJsService.DecryptDataPayload(data.data);
    //       this.loader.close();
    //       if (data == 'Already Sent OTP to Mobile Number!') {
    //         this.f.otp.enable();
    //         this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Already Sent OTP to Mobile Number!' });
    //         return;
    //       }
    //       let otpData = data.toString().split(',');
    //       if (otpData.length > 0) {
    //         otpData = otpData[0].toString().split(':');
    //       }
    //       this.validationOTP = otpData[1].trim();
    //       this.f.otp.enable();
    //       this.service.add({ severity: 'success', summary: 'Success Message', detail: 'OTP Generated Successfully!' });
    //     },
    //     error: () => {
    //       this.loader.close();
    //       this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! OTP not generated.' });
    //     },
    //     complete: () => {
    //       this.reloadCaptcha();
    //     }
    //   });
  }

  sendAadharOTP() {
    // this.isOTPSend = true;
    // this.f.aadhar.disable();
    // this.f.otp.enable();
    // this.disableOTPButton(1);
    // this.reloadCaptcha();

    let aadharNumber = this.f.aadhar.value;
    let reqBody = {
      "AadharNo": aadharNumber
    };

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }
    this.loader.start();
    this.farmersDetailsService.generateAadharOTPFarmer(reqBodyAfterEncypt).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          this.reloadCaptcha();
          if (data == "OTP sent") {
            this.service.add({ severity: 'success', summary: 'Success Message', detail: data });
            this.isOTPSend = true;
            this.f.aadhar.disable();
            this.f.otp.enable();
            this.disableOTPButton(5);
          } else {
            this.service.add({ severity: 'warn', summary: 'Error Message', detail: data });
            this.isOTPSend = false;
          }

          this.activityRecordService.activityRecord(aadharNumber, 'Farmer Login - Get Aadhar OTP', '', new Date(), data, aadharNumber);
        },
        error: (err) => {
          this.service.add({ severity: 'error', summary: 'Error Message', detail: err });
          this.loader.close();

          this.isOTPSend = false;

          this.activityRecordService.activityRecord(aadharNumber, 'Farmer Login - Get Aadhar OTP(error)', '', new Date(), err, aadharNumber);
        }
      });
  }

  disableOTPButton(minutes: number) {
    let seconds: number = minutes * 60;
    let textSec: any = "00";
    let statSec: number = 60;

    const prefix = minutes < 10 ? "0" : "";

    // Clear any previous timer if needed
    if (this.otpTimer) {
      clearInterval(this.otpTimer);
    }

    this.display = `${prefix}${Math.floor(seconds / 60)}:00`;

    this.otpTimer = setInterval(() => {
      seconds--;
      if (statSec !== 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else {
        textSec = statSec;
      }

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds === 0) {
        clearInterval(this.otpTimer);
        this.display = null;
        this.isOTPSend = false;
        this.f.aadhar.enable();
        this.f.otp.disable();
        this.f.otp.setValue('');
      }
    }, 1000);
  }

  showError() {
    this.service.add({ severity: 'warn', summary: 'Invalid CAPTCHA', detail: 'Captcha is not matching!' });
  }

  login() {
    this.submitted = true;

    if (this.captch_input !== this.resultCode) {
      this.showError();
      this.captch_input = "";
      this.reloadCaptcha();
      return;
    }

    const aadharNumber = this.f.aadhar.value;
    if (!aadharNumber || aadharNumber.length < 12) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Something went wrong please try again.' });
      return;
    }

    const otp = this.f.otp.value;
    if (!otp || otp.length < 6) {
      this.service.add({ severity: 'warn', summary: 'Warning Message', detail: 'Enter valid OTP' });
      return;
    }

    // stop here if form is invalid
    if (this.onAuthForm.invalid) {
      this.activityRecordService.activityRecord(aadharNumber, 'farmer_login', '', new Date(), 'Invalid Login');

      this.service.add({ severity: 'error', summary: 'Error Message', detail: "Invalid Input" });
      return;
    }

    // let body = {
    //   "mobileNo": this.cryptoJS.Encrypt(this.onAuthForm.controls.phoneNo.value),
    //   "otp": this.cryptoJS.Encrypt(JSON.stringify(Number(this.onAuthForm.controls.otp.value)))
    // }

    const reqBody = {
      AadharNo: aadharNumber,
      OTP: otp
    }

    this.submitOTP(reqBody);
  }

  submitOTP(reqBody: any) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.farmersDetailsService.validateAadharOTPFarmer(reqBodyFinal).pipe(first())
      .subscribe({
        next: (resp: any) => {
          this.loader.close();
          if (resp == null || resp.data == null) {
            "UIDAI service is down...Please try after some time";
            this.activityRecordService.activityRecord(reqBody?.AadharNo, 'farmer_login', '', new Date(), `OTP Validation Failed ${resp}`, reqBodyFinal);
            this.service.add({ severity: 'error', summary: 'Error Message', detail: `OTP Validation Failed. ${resp}` });
            // setTimeout(() => window.location.reload(), 3000);
            return;
          } else if (resp.data) {
            sessionStorage.setItem("token", resp.data)
            let data = JSON.parse(this.cryptoJsService.DecryptToken(resp.data));

            let payload = atob(data.authToken?.split('.')[1]);
            const loginId = JSON.parse(payload)?.sub;

            
            if (data?.authToken) {
              if (data['msg'] && data['msg'] != null) {
                this.service.add({ severity: 'error', summary: 'Error Message', detail: data?.msg });
                sessionStorage.removeItem("token");
                setTimeout(() => window.location.reload(), 3000);
                return;
              }
              // window.sessionStorage.setItem("token", this.cryptoJsService.EncryptPayload(JSON.stringify(data)));
              const farmerDetails = new Map();

              farmerDetails.set('farmerPh', loginId);
              farmerDetails.set('ownMIfarmerPh', loginId);
              farmerDetails.set('userID', 'ownMIfarmer');
              farmerDetails.set('isFarmerLogin', '1');
              farmerDetails.set('isOwnMIFarmerLogin', '1');
              farmerDetails.set('AadharStatus_', data?.AadharStatus);
              farmerDetails.set('Farmer_Id_', data?.UserId_New == "" ? null : data?.UserId_New);
              farmerDetails.set('ipAddress', this.ipAddress);

              const dataF = JSON.stringify(Array.from(farmerDetails.entries()));
              sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));

              // this.router.navigate(['farmer/dashboard']);
              this.activityRecordService.activityRecord(reqBody?.AadharNo, 'farmer_login(tubewell-connection-dashboard)', '', new Date(), 'Success', reqBodyFinal);
              this.router.navigate(['tubewell-connection-dashboard']);

            } else {
              this.activityRecordService.activityRecord(reqBody?.AadharNo, 'farmer_login(tubewell-connection-dashboard)', '', new Date(), 'OTP Validation Failed', reqBodyFinal);

              this.service.add({ severity: 'error', summary: 'Error Message', detail: "OTP Validation Failed" });
              // setTimeout(() => window.location.reload(), 3000);
            }
          } else {
            this.activityRecordService.activityRecord(reqBody?.AadharNo, 'farmer_login(tubewell-connection-dashboard)', '', new Date(), `OTP Validation Failed. ${resp}`, reqBodyFinal);

            this.service.add({ severity: 'error', summary: 'Error Message', detail: `OTP Validation Failed. ${resp}` });
            // setTimeout(() => window.location.reload(), 3000);
          }

        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.onAuthForm.controls.phoneNo.value, 'farmer_login', '', new Date(), err[0], reqBodyFinal);
          this.service.add({ severity: 'error', summary: 'Error Message', detail: err[0] });
          this.reloadCaptcha();
        },
        complete: () => {
        }
      });
  }

  reloadPage() {
    window.location.reload();
  }

  goBack() {
    window.history.back();
  }

  preventArrowKeys(event: KeyboardEvent): void {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  }

  preventScroll(event: WheelEvent): void {
    event.preventDefault();
  }

  getIP() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let ipAddress = farmerConfData.get('ipAddress');

    if (ipAddress) {
      this.ipAddress = ipAddress;
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;

        // farmerConfData.set('ipAddress', this.ipAddress)

        // const dataF = JSON.stringify(Array.from(farmerConfData.entries()));
        // sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));  
      });
    }
  }

  onOtpInput(event: any, index: number) {
    const value = event.target.value;
    if (value && /^[0-9]$/.test(value)) {
      this.otpBoxValues[index] = value;
      // Move to next box if not last
      if (index < 5) {
        const nextBox = document.getElementById('otp' + (index + 1));
        if (nextBox) (nextBox as HTMLInputElement).focus();
      }
    } else {
      this.otpBoxValues[index] = '';
    }
    this.updateOtpFormControl();
  }

  // Handle backspace
  onOtpKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace' && !this.otpBoxValues[index] && index > 0) {
      const prevBox = document.getElementById('otp' + (index - 1));
      if (prevBox) (prevBox as HTMLInputElement).focus();
    }
  }

  // Update the form control value
  updateOtpFormControl() {
    const otp = this.otpBoxValues.join('');
    this.onAuthForm.controls['otp'].setValue(otp);
    this.otpBoxError = otp.length !== 6 || !/^\d{6}$/.test(otp);
  }

}
